import MpnLabelNumber from './MpnLabelNumber.vue';
import MpnInputNumberOnly from './MpnInputNumberOnly.vue';
import MpnBasicButton from './MpnBasicButton.vue';
import MpnPageTitle from './MpnPageTitle.vue';
import MpnSectionTitle from './MpnSectionTitle.vue';

export default {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.component(MpnLabelNumber.name, MpnLabelNumber);
    Vue.component(MpnInputNumberOnly.name, MpnInputNumberOnly);
    Vue.component(MpnBasicButton.name, MpnBasicButton);
    Vue.component(MpnPageTitle.name, MpnPageTitle);
    Vue.component(MpnSectionTitle.name, MpnSectionTitle);
  },
};
